import React from "react";
import { useEffect, useState } from 'react';
import "./FormContainer.css";

import logo from "../../../assets/img/logo-header.png";

export default function FormContainer({ children, onClose }) {
  return (
    <div className="FormContainer">
        <div className="FormContainer-header">
          <div className="FormContainer-Fechar" onClick={onClose}> X </div>

          <img src={logo} alt="Logotipo" className="FormContainer-logo" />
        </div>

        <div className="FormContainer-content">
          {children}
        </div>
    </div>
  );
}
